module.exports = __webpack_public_path__ + "img/pinBSky.309cb7ef.png";